// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc34f9eb","788":"846967bf"}[chunkId] + ".chunk.js";
};